import { useCallback } from 'react';
import orderBy from 'lodash/orderBy';
import { ICarDetail } from 'src/redux/carDetails/carDetails.duck.interface';
import { getTotalPriceObjByType } from '@utils/Price.utils';
import { IFeature, IPriceV2, IPriceV2Types } from 'src/services';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from 'src/context/featureSwitchApp';

export type Features = {
    engines: IFeature[];
    exteriorColors: IFeature[];
    interiorColors: IFeature[];
};

interface ITrim {
    vehicle: ICarDetail;
    features: Features;
    parsedPrice: number;
    parsedPriceCatalogue: number;
}
export const useTrimsOrder = (trims: Array<{ vehicle: ICarDetail; features: Features }>, type: IPriceV2Types) => {
    const isSOLEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_SOL_ENABLED);

    const orderAscByCataloguePrice = useCallback(
        () =>
            orderBy(
                trims?.map((trim: { vehicle: ICarDetail }) => {
                    const priceObj = getTotalPriceObjByType(
                        trim?.vehicle?.extraFields?.pricesV2 || trim?.vehicle?.pricesV2,
                        type
                    );

                    return {
                        ...trim,
                        parsedPrice: isSOLEnabled
                            ? priceObj?.breakdown.finalCustomerCashPriceOnTheRoad
                            : priceObj?.finalPriceInclTax,
                        parsedPriceCatalogue: trim.vehicle.pricesV2.find(
                            (item: IPriceV2) => item.type === IPriceV2Types.TOTAL_CATALOG_CASH
                        )?.finalPriceInclTax,
                    };
                }),
                ['parsedPriceCatalogue'],
                ['asc']
            ) as Array<ITrim>,
        [trims]
    );

    return {
        orderAscByCataloguePrice,
    };
};
